;!function(){try{var e="undefined"!=typeof window?window:"undefined"!=typeof global?global:"undefined"!=typeof self?self:{},n=(new e.Error).stack;n&&(e._sentryDebugIds=e._sentryDebugIds||{},e._sentryDebugIds[n]="75f910c9-1d09-473f-9c0e-e9b35cd74199",e._sentryDebugIdIdentifier="sentry-dbid-75f910c9-1d09-473f-9c0e-e9b35cd74199")}catch(e){}}();import classNames from '../../node_modules/.pnpm/classnames@2.5.1/node_modules/classnames/index.js';
import React__default, { useContext } from 'react';
import 'react/jsx-runtime';
import ArrowAngleRight from '../../node_modules/.pnpm/@zooplus_icons@2.3.0_react-dom@18.3.1_react@18.3.1/node_modules/@zooplus/icons/dist/es/components/ArrowAngleRight.js';
import AppContext from '../../context/AppContext.js';
import '../../_virtual/_sentry-release-injection-file.js';
import BonusPointsBanner from '../BonusPoints/BonusPointsBanner.js';
import { ThemedIcon } from '../Icon/Icon.js';
import styles from './BurgerNavigation.module.scss.js';

function BurgerPanel({ onClickNextPanel, openPanels, }) {
    const { translations, isLoggedIn, bonuspointsAvailable, customerStatusLoaded, } = useContext(AppContext);
    const accessibleLabel = translations.get('shop.header.main.navigation.category.accessible.button.label');
    const { currentPath } = openPanels.slice(-1)[0];
    return (React__default.createElement(React__default.Fragment, null, openPanels.map((panel, index) => (React__default.createElement("ul", { className: classNames(styles.burgerPanelList, styles.scrollBox), key: panel.currentPath, id: panel.trackingId },
        index === 0 &&
            customerStatusLoaded &&
            isLoggedIn &&
            bonuspointsAvailable && React__default.createElement(BonusPointsBanner, null),
        panel.items.map(({ path, title, hasChildren, isSpecial, highlighted, active, isParent: isParentLink, isBold, isSeperator, }) => {
            const isDisabled = currentPath !== panel.currentPath;
            const isHighlighted = isSpecial || highlighted;
            const itemLink = currentPath === panel.currentPath
                ? path
                : undefined;
            if (!hasChildren) {
                return (React__default.createElement("li", { key: path, "data-zta": isParentLink
                        ? 'burger-nav-item-parent'
                        : 'burger-nav-item-no-child', className: classNames(styles.burgerItem, {
                        [styles.burgerItemActive]: active,
                        [styles.burgerItemParentLink]: isParentLink,
                        [styles.burgerItemBold]: isBold,
                        [styles.burgerItemSeperator]: isSeperator,
                    }) },
                    React__default.createElement("a", { href: itemLink, "data-zta": "burger-nav-item-link", className: classNames(styles.burgerItemLink, {
                            [styles.burgerItemLinkSpecial]: isHighlighted,
                        }) },
                        React__default.createElement("span", null, title))));
            }
            return (React__default.createElement("li", { key: path, "data-zta": "burger-nav-item-with-children", className: classNames(styles.burgerItem, {
                    [styles.burgerItemActive]: active,
                    [styles.burgerItemBold]: isBold,
                    [styles.burgerItemSeperator]: isSeperator,
                }) },
                React__default.createElement("button", { type: "button", "data-zta": "burger-nav-item-btn", className: styles.burgerItemButton, onClick: () => onClickNextPanel(path), disabled: isDisabled },
                    React__default.createElement("span", null, title),
                    React__default.createElement(ThemedIcon, { color: "neutralDark", Icon: ArrowAngleRight, "aria-label": accessibleLabel, "data-zta": "angleRightIcon" }))));
        }))))));
}

export { BurgerPanel as default };
//# sourceMappingURL=BurgerPanel.js.map
